<template>
  <basic-container>
    <div
      class="path-container"
      style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>健康管理护士工作站</el-breadcrumb-item>
        <el-breadcrumb-item>押金列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <avue-crud
      :option="option"
      :data="data"
      :page.sync="page"
      ref="crud"
      v-model="form"
      :permission="permissionList"
      :before-open="beforeOpen"
      @row-update="rowUpdate"
      @refresh-change="refreshChange"
      @on-load="onLoad"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" @click="openExpress(scope.row)">
          录单号
        </el-button>
        <el-button
          type="text"
          size="small"
          @click="$refs.crud.rowEdit(scope.row, scope.index)"
        >
          编辑
        </el-button>
        <el-button
          type="text"
          size="small"
          @click="$refs.crud.rowView(scope.row, scope.index)"
        >
          查看
        </el-button>
        <el-button type="text" size="small" @click="auditPass(scope.row)">
          审核通过
        </el-button>
        <el-button type="text" size="small" @click="openReject(scope.row)">
          驳回
        </el-button>
      </template>
    </avue-crud>

    <el-dialog title="录入快递单号" :visible.sync="expressVisible" width="30%">
      <el-input
        v-model="expressNo"
        placeholder="请输入快递单号"
        clearable
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="expressVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveExpress">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="驳回" :visible.sync="rejectVisible" width="30%">
      <el-input
        type="textarea"
        :rows="4"
        v-model="rejectReason"
        placeholder="请输入驳回原因"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rejectVisible = false">取 消</el-button>
        <el-button type="primary" @click="auditReject">确 定</el-button>
      </span>
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from "vuex";
//这里是接口相关地址，需要在manage文件中加相应接口
import { getList, getDetail, submit, audit, saveExpressNo } from "@/api/health/manage";

// 状态字典：申请 -> 审核 -> 寄回 -> 收货   这里是自定义的状态，看下和后台是否统一
const statusDic = [
  { label: "申请中", value: 0 },
  { label: "已通过", value: 1 },
  { label: "已驳回", value: 2 },
  { label: "未发货", value: 3 },
  { label: "已发货", value: 4 },
  { label: "已收货", value: 5 },
];

// 谢工，这里是我的测试数据，接接口时把 data中的useMock 改成 false 并删掉 mockRecords
const mockRecords = [
  {
    id: 1,
    userName: "郭苗苗",
    account: "13331336208",
    address: "河北省张家口市红旗楼街道",
    deviceNo: "GU9876",
    status: 4,
    expressNo: "1342134251425",
    rejectReason: "",
  },
];

export default {
  data() {
    return {
      useMock: true,
      form: {},
      data: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      headerCellClassName: "headerClass",
      expressVisible: false,
      rejectVisible: false,
      expressNo: "",
      rejectReason: "",
      currentRow: {},
      option: {
        tip: false,
        border: true,
        addBtn: false,
        editBtn: false,
        viewBtn: false,
        delBtn: false,
        menuWidth: 220,
        column: [
          {
            label: "用户",
            prop: "userName",
            rules: [
              {
                required: true,
                message: "请输入用户",
              },
            ],
          },
          {
            label: "账号",
            prop: "account",
            rules: [
              {
                required: true,
                message: "请输入账号",
              },
            ],
          },
          {
            label: "地址",
            prop: "address",
            span: 24,
            rules: [
              {
                required: true,
                message: "请输入地址",
              },
            ],
          },
          {
            label: "设备号",
            prop: "deviceNo",
            rules: [
              {
                required: true,
                message: "请输入设备号",
              },
            ],
          },
          {
            label: "状态",
            prop: "status",
            type: "select",
            dicData: statusDic,
            rules: [
              {
                required: true,
                message: "请选择状态",
              },
            ],
          },
          {
            label: "快递单号",
            prop: "expressNo",
          },
          {
            label: "驳回原因",
            prop: "rejectReason",
            type: "textarea",
            hide: true,
            span: 24,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.health_deposit_add,
        viewBtn: this.permission.health_deposit_view,
        delBtn: this.permission.health_deposit_delete,
        editBtn: this.permission.health_deposit_edit,
      };
    },
  },
  methods: {
    onLoad(page, params = {}) {
      if (this.useMock) {
        this.data = mockRecords;
        this.page.total = mockRecords.length;
        return;
      }
      getList(page.currentPage, page.pageSize, params).then((res) => {
        const data = res.data;
        this.page.total = data.total;
        this.data = data.records;
      });
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm);
    },

    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getDetail(this.form.id).then((res) => {
          this.form = res.data;
        });
      }
      done();
    },

    rowUpdate(row, index, done, loading) {
      submit(row)
        .then(() => {
          done();
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        })
        .catch(() => {
          loading();
        });
    },

    openExpress(row) {
      this.currentRow = row;
      this.expressNo = row.expressNo || "";
      this.expressVisible = true;
    },

    saveExpress() {
      if (!this.expressNo) {
        this.$message.warning("请输入快递单号");
        return;
      }
      saveExpressNo({
        id: this.currentRow.id,
        expressNo: this.expressNo,
      }).then(() => {
        this.expressVisible = false;
        this.onLoad(this.page);
        this.$message({
          type: "success",
          message: "操作成功!",
        });
      });
    },

    auditPass(row) {
      this.$confirm("确定审核通过该条数据?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return audit({
            id: row.id,
            status: 1,
          });
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },

    openReject(row) {
      this.currentRow = row;
      this.rejectReason = "";
      this.rejectVisible = true;
    },

    auditReject() {
      if (!this.rejectReason) {
        this.$message.warning("请输入驳回原因");
        return;
      }
      audit({
        id: this.currentRow.id,
        status: 2,
        rejectReason: this.rejectReason,
      }).then(() => {
        this.rejectVisible = false;
        this.onLoad(this.page);
        this.$message({
          type: "success",
          message: "操作成功!",
        });
      });
    },
  },
};
</script>

<style scoped>
.headerClass {
  background-color: #409eff !important;
  color: #fff !important;
}
</style>
